function tab() {
  let tabButtons = document.getElementsByClassName('tab-button'), currActiveEl, currActiveTargetEl
  if(tabButtons.length < 1) return
  
  for (let i = 0; i < tabButtons.length; i++) {
    let el = tabButtons[i]
    if(el.classList.contains('tab-button--active')) {
      currActiveEl = el
      currActiveTargetEl = document.getElementById(el.getAttribute('data-target-id'))
    }
    el.addEventListener('click', tabButtonClickHandler)
  }
  
  function tabButtonClickHandler(e) {
    e.preventDefault()
    let el = e.target, targetElementId = el.getAttribute('data-target-id')
  
  
    // debugger
    if(el === currActiveEl) return
  
    if(currActiveEl) {
      currActiveEl.classList.remove('tab-button--active') // remove 
      if(currActiveTargetEl) currActiveTargetEl.style.display = 'none'
    }
  
    currActiveEl = el
    currActiveEl.classList.add('tab-button--active')
  
    currActiveTargetEl = document.getElementById(targetElementId)
    
    if (currActiveTargetEl) {
      currActiveTargetEl.style.display = 'block' // display it
    }
  } 
}

function carousel() {
  // let x = new Swiper()
  const SwiperInstance1 = new Swiper('.myCarousel', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 30,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
    },
  })
  // debugger
}

function testimonial() {
  // let x = new Swiper()
  const SwiperInstance1 = new Swiper('.myTestimonial', {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoHeight: true,
    autoplay: {
      delay: 30000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })
}

window.addEventListener('DOMContentLoaded', function() {
  tab()
  carousel()
  testimonial()
})
